import { createSlice } from '@reduxjs/toolkit';
import { copyPinboardItems } from './actions/copyPinboardItems';
import { createPinboard } from './actions/createPinboard';
import { createPinboardItem } from './actions/createPinboardItem';
import { deletePinboard } from './actions/deletePinboard';
import { deletePinboardItem } from './actions/deletePinboardItem';
import { movePinboardItems } from './actions/movePinboardItems';
import { retrievePinboards } from './actions/retrievePinboards';
import { savePinboards } from './actions/savePinboards';
import { updatePinboard } from './actions/updatePinboard';
const INITIAL_STATE = {
    drawer: {
        isActive: false,
    },
    items: [],
    saveData: null,
};
export const pinboards = createSlice({
    initialState: INITIAL_STATE,
    name: 'pinboards',
    reducers: {
        showDrawer(state, action) {
            state.drawer.isActive = true;
            state.drawer.params = action.payload;
        },
        hideDrawer(state) {
            state.drawer.isActive = false;
            state.drawer.params = undefined;
        },
    },
    extraReducers(builder) {
        builder.addCase(copyPinboardItems.fulfilled, (state, action) => {
            state.items = action.payload.items;
        });
        builder.addCase(createPinboard.fulfilled, (state, action) => {
            state.items = action.payload.items;
        });
        builder.addCase(createPinboardItem.fulfilled, (state, action) => {
            state.items = action.payload.items;
        });
        builder.addCase(deletePinboard.fulfilled, (state, action) => {
            state.items = action.payload.items;
        });
        builder.addCase(deletePinboardItem.fulfilled, (state, action) => {
            state.items = action.payload.items;
        });
        builder.addCase(movePinboardItems.fulfilled, (state, action) => {
            state.items = action.payload.items;
        });
        builder.addCase(retrievePinboards.fulfilled, (state, action) => {
            state.items = action.payload.items;
        });
        builder.addCase(savePinboards.fulfilled, (state, action) => {
            state.saveData = action.payload;
        });
        builder.addCase(updatePinboard.fulfilled, (state, action) => {
            state.items = action.payload.items;
        });
    },
});
